import React from 'react'
import Header from '../component/layout/Header'
import Footer from '../component/layout/Footer'
import Wallet from "../component/User/Wallet/Wallet.jsx"
import RewardPopup from '../component/User/Wallet/Reward.jsx'
const WalletPage = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the page loads
  }, []);
  return (
    <>
    <Header/>
    <Wallet/>
    {/* <RewardPopup/> */}
    <Footer/>
    </>
  )
}

export default WalletPage